module.exports = __webpack_public_path__ + "static/media/noborder.e34e68b6.svg";